import * as React from 'react';
import { MdArrowDropDown, MdFolder } from 'react-icons/md';
import { Tooltip } from 'ui/common/tooltip/tooltip';
import { BigSVGCheckbox } from 'app/components/code-selector/big-svg-checkbox';
import { SelectOptionValue } from 'app/area/code-selector/types';
import styles from './select-option-button.scss';

export interface SelectOptionButtonProps {
  data: SelectOptionValue;
  onClick: (caseType: SelectOptionValue) => void;
  onExpand: (item: SelectOptionValue) => void;
  checkbox: {checkedState: boolean};
}

export class SelectOptionButton extends React.PureComponent<SelectOptionButtonProps, any> {
  private onClick = (e: any) => {
    e.preventDefault();
    if (this.props.onClick) {
      this.props.onClick(this.props.data);
    }
  };

  private onExpand = (e: any) => {
    e.preventDefault();
    this.props.onExpand(this.props.data);
  };

  public render() {
    const { data, checkbox } = this.props;

    const icon = !!data.icon && <img className={`${styles.selectCodeBtnIcon}`} src={data.icon} />;
    const folder = <MdFolder className={`${styles.selectCodeBtnIcon}`} />;

    const isFolder = !!data.descendants && data.descendants.length > 0;

    const isCheckedClass = !!checkbox && !!checkbox.checkedState ? styles.isChecked : styles.notChecked;

    return (<li className={`col-6 col-md-4 col-lg-3 col-xl-2 ${styles.selectOptionCheckbox} select-option ${isCheckedClass}`}>
      <button onClick={isFolder ? this.onExpand : this.onClick}>
        <Tooltip className={`${styles.selectCodeBtn} ${isFolder && styles.selectFolder}`} title={data.longDescription}>
          {isFolder ? folder : icon}
          <span className={`${styles.selectCodeBtnTitle}`}>{data.description}{isFolder && <MdArrowDropDown />}</span>
          { !!checkbox && !isFolder && <BigSVGCheckbox isChecked={!!checkbox.checkedState}/> }
        </Tooltip>
      </button>
    </li>);
  }
}
